import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e437b80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-info" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "info-left" }
const _hoisted_4 = { class: "total" }
const _hoisted_5 = { class: "info-right" }
const _hoisted_6 = {
  class: "info-list",
  id: "info-list"
}
const _hoisted_7 = {
  class: "info-box",
  id: "info-box"
}
const _hoisted_8 = {
  key: 0,
  class: "get-more"
}
const _hoisted_9 = {
  key: 0,
  class: "loading-info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiazaizhong" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "info-left" }
const _hoisted_15 = { class: "info-right" }
const _hoisted_16 = { class: "video-name one-line" }
const _hoisted_17 = { class: "video-attr one-line" }
const _hoisted_18 = { class: "more-info" }
const _hoisted_19 = { class: "video-data" }
const _hoisted_20 = { class: "video-click" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/icon/play.png" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "get-more"
}
const _hoisted_23 = {
  key: 0,
  class: "loading-info"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiazaizhong" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("播放列表"),
        _createElementVNode("span", _hoisted_4, "(共" + _toDisplayString(_ctx.total) + "个)", 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass({ active: _ctx.sort == 0 }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSort(0)))
        }, "最新", 2),
        _createElementVNode("span", {
          class: _normalizeClass({ active: _ctx.sort == 1 }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSort(1)))
        }, "人气", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.aboutGoodsList.data.length > 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.topMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : (_openBlock(), _createElementBlock("p", _hoisted_12, "没有更多了"))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutGoodsList.data, (goods, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["info", { active: goods.id == _ctx.nowid }]),
            key: index,
            onClick: ($event: any) => (_ctx.sedGoodsInfo(index))
          }, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("img", null, null, 512), [
                [_directive_lazy, _ctx.imgUrl(goods.names, goods.cover)]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, _toDisplayString(goods.names), 1),
              _createElementVNode("p", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goods.attr, (attr, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createTextVNode(_toDisplayString(goods.attr) + " ", 1)
                  ], 64))
                }), 256))
              ]),
              _createElementVNode("p", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.dateFormatMap(goods.update_time * 1000)), 1),
                _createElementVNode("span", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(goods.click), 1)
                ])
              ])
            ])
          ], 10, _hoisted_13))
        }), 128)),
        (_ctx.aboutGoodsList.data.length > 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_ctx.bottomMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                : (_openBlock(), _createElementBlock("p", _hoisted_26, "没有更多了"))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}